import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a871914"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-justify-center p-align-center p-text-bold p-mt-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-mr-2" }, "Natural user", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Legal user", -1))
const _hoisted_4 = {
  key: 1,
  class: "body-modal"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Legal Person Type", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Legal Representative First Name", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Legal Representative Last Name", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Legal Representative Nationality", -1))
const _hoisted_9 = {
  key: 0,
  class: "country-item country-item-value"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "country-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Legal Representative Country Of Residence", -1))
const _hoisted_13 = {
  key: 0,
  class: "country-item country-item-value"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "country-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Legal Representative Birthday", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address Line 1", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "City", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Postal Code", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "County", -1))
const _hoisted_22 = {
  key: 0,
  class: "country-item country-item-value"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "country-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "IBAN/SWIFT:", -1))
const _hoisted_26 = {
  key: 2,
  class: "body-modal"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "First Name", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Last Name", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("We use this for security purposes and identity verification "),
  /*#__PURE__*/_createElementVNode("span", null, "Read More")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Birthday", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Nationality", -1))
const _hoisted_32 = {
  key: 0,
  class: "country-item country-item-value"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "country-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Country Of Residence", -1))
const _hoisted_36 = {
  key: 0,
  class: "country-item country-item-value"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "country-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("We use this for security purposes and identity verification "),
  /*#__PURE__*/_createElementVNode("span", null, "Read More")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address Line 1", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "City", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Postal Code", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "County", -1))
const _hoisted_45 = {
  key: 0,
  class: "country-item country-item-value"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "country-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "IBAN/SWIFT::", -1))
const _hoisted_49 = { class: "p-d-flex p-justify-center p-mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_Dialog, {
      header: "Payment Information",
      visible: $setup.displayModalInfo,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => (($setup.displayModalInfo) = $event)),
      style: { width: '35vw' },
      modal: true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          (!$props.isCreator)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Submit Info",
                onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.checkedUser ? $setup.handleSubmitLegal() : $setup.handleSubmit())),
                class: "continue-button"
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                label: "Submit Info",
                onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.checkedUser ? $setup.influencerLegaldata() : $setup.influencerData())),
                class: "continue-button"
              }))
        ])
      ]),
      default: _withCtx(() => [
        ($props.isCreator)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_InputSwitch, {
                modelValue: $setup.checkedUser,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedUser) = $event)),
                class: "p-mr-2"
              }, null, 8, ["modelValue"]),
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        ($setup.checkedUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalPersonType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.LegalPersonType) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_6,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeFirstName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.LegalRepresentativeFirstName) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_7,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeLastName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.LegalRepresentativeLastName) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_8,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.LegalRepresentativeNationality,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.LegalRepresentativeNationality) = $event)),
                options: $setup.countries,
                optionLabel: "name",
                filter: true,
                class: "inp-default",
                placeholder: "Select a Nationality",
                showClear: true
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"]),
              _hoisted_12,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.LegalRepresentativeCountryOfResidence,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.LegalRepresentativeCountryOfResidence) = $event)),
                options: $setup.gigapaySupportedCountries,
                optionLabel: "name",
                filter: true,
                class: "inp-default",
                placeholder: "Select a Country Of Residence",
                showClear: true
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"]),
              _hoisted_16,
              _createVNode(_component_Calendar, {
                id: "icon",
                class: "default-input calendar",
                modelValue: $setup.Birthday,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.Birthday) = $event)),
                showIcon: true
              }, null, 8, ["modelValue"]),
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeAddress.AddressLine1,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.LegalRepresentativeAddress.AddressLine1) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_19,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeAddress.City,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.LegalRepresentativeAddress.City) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_20,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeAddress.PostalCode,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.LegalRepresentativeAddress.PostalCode) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_21,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.LegalRepresentativeAddress.Country,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.LegalRepresentativeAddress.Country) = $event)),
                options: $setup.countries,
                optionLabel: "name",
                filter: true,
                class: "inp-default",
                placeholder: "Select a Country",
                showClear: true
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"]),
              _hoisted_25,
              _createVNode(_component_InputText, {
                type: "text",
                class: "iban-input inp-default d-align w-100",
                modelValue: $setup.iban,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.iban) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (!$setup.checkedUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_InputText, {
                style: _normalizeStyle([$setup.FirstName.length < 3 ? 'border: 1px solid red' : '']),
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.FirstName,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.FirstName) = $event))
              }, null, 8, ["style", "modelValue"]),
              _hoisted_28,
              _createVNode(_component_InputText, {
                type: "text",
                class: "default-input",
                modelValue: $setup.LastName,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.LastName) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_29,
              _hoisted_30,
              _createVNode(_component_Calendar, {
                id: "icon",
                class: "default-input calendar",
                modelValue: $setup.Birthday,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.Birthday) = $event)),
                showIcon: true
              }, null, 8, ["modelValue"]),
              _hoisted_31,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.Nationality,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.Nationality) = $event)),
                options: $setup.countries,
                optionLabel: "name",
                filter: true,
                class: _normalizeClass([[!!$setup.Nationality ? '' : 'p-invalid'], "inp-default"]),
                placeholder: "Select a Country",
                showClear: true
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "class"]),
              _hoisted_35,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.CountryOfResidence,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.CountryOfResidence) = $event)),
                options: $setup.gigapaySupportedCountries,
                optionLabel: "name",
                filter: true,
                class: _normalizeClass([[!!$setup.CountryOfResidence ? '' : 'p-invalid'], "inp-default"]),
                placeholder: "Select a Country Of Residence",
                showClear: true
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "class"]),
              _hoisted_39,
              _hoisted_40,
              _hoisted_41,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeAddress.AddressLine1,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.LegalRepresentativeAddress.AddressLine1) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_42,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeAddress.City,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.LegalRepresentativeAddress.City) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_43,
              _createVNode(_component_InputText, {
                required: "",
                type: "text",
                class: "default-input",
                modelValue: $setup.LegalRepresentativeAddress.PostalCode,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.LegalRepresentativeAddress.PostalCode) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_44,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.LegalRepresentativeAddress.Country,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.LegalRepresentativeAddress.Country) = $event)),
                options: $setup.countries,
                optionLabel: "name",
                filter: true,
                class: "inp-default",
                placeholder: "Select a Country",
                showClear: true
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"]),
              _hoisted_48,
              _createVNode(_component_InputText, {
                type: "text",
                class: "iban-input inp-default d-align w-100",
                modelValue: $setup.iban,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.iban) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}